import { Component, Input, OnInit } from '@angular/core';
import { GlobalsService } from '@app/services/globals.service';
import { unsubscribe } from '@app/utils';
import { Subscription } from 'rxjs';

/**
 * Componente de banner con icono de exclamación.
 * Muestra mensajes dinámicos y se adapta al idioma seleccionado.
 */
@Component({
    selector: 'app-banner-exclamation',
    templateUrl: './am-banner-exclamation.component.html',
    styleUrls: ['./am-banner-exclamation.component.scss'],
    standalone: false
})
export class BannerExclamationComponent implements OnInit {
 /**
   * Primer texto del banner.
   */
 @Input() copyTxt1: string = '';

 /**
  * Segundo texto del banner.
  */
 @Input() copyTxt2: string = '';

 /**
  * Suscripciones activas para manejar eventos.
  */
 subs: Subscription[] = [];

 /**
  * Idioma actual de la aplicación.
  */
 language: string = '';

  constructor( private _globalService: GlobalsService) { }
 /**
   * Se suscribe al servicio de idioma para detectar cambios.
   */
  ngOnInit(): void {
    const sub = this._globalService.language$.subscribe({
      next:(lang) => {
        this.language = lang;
      }
  })
  this.subs.push(sub)
  }
/**
   * Cancela todas las suscripciones activas al destruir el componente.
   */
  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }

}
